import React from 'react';

export default function VideoEmbed(prop) {
  // Defaults to Youtube
  const providerEmbedUrl = () => {
    switch (prop.videoSource) {
      case 'vimeo':
        return `https://player.vimeo.com/video/${prop.embedId}?autoplay=0`;
      default:
        return `https://www.youtube.com/embed/${prop.embedId}?autoplay=0&rel=0&showinfo=0`;
    }
  };
  return (
    <div className="VideoEmbedContainer">
      <h2>{prop.videoTitle}</h2>
      <iframe
        className="VideoIframe"
        src={providerEmbedUrl()}
        allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        title={`${prop.videoTitle}`}
      />
    </div>
  );
}
